<template>
	<multi-select
		min-height="32px"
		class="p-multi-select"
		:options="options"
		:value="localSelectedItems"
		@input="handleInput($event)"
		:data-content="localSelectedItems.length > 0 ? '' : placeholder"
	>
		<template slot="tag" slot-scope="{ tag }">
			<span class="p-multi-select--tag"
				>{{ tag[prop] }}
				<!--
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					class="bi bi-x"
					viewBox="0 0 16 16"
				>
					<path
						d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
					/></svg
			> -->
			</span>
		</template>
		<template slot="icon">
			<span class="p-multi-select--icon"></span>
		</template>
		<template slot="menu" slot-scope="{ menuItem }">
			<div
				class="p-multi-select--item"
				:class="{ 'p-multi-select--item__selected': isSelected(menuItem) }"
			>
				{{ menuItem[prop] }}
			</div>
		</template>
	</multi-select>
</template>

<script>
import MultiSelect from 'multiselect-dl';
import { findIndex, propEq, reject } from 'ramda';

export default {
	name: 'PMultiSelect',
	components: { MultiSelect },
	props: {
		options: {
			default: [],
			required: true,
		},
		prop: {
			required: true,
		},
		placeholder: {
			default: '',
		},
		selectedOptions: {
			default: [],
		},
	},
	data() {
		return {
			localSelectedItems: [],
		};
	},
	methods: {
		handleInput([selectedItem]) {
			if (this.isSelected(selectedItem)) {
				this.localSelectedItems = reject(
					propEq(this.prop, selectedItem[this.prop]),
					this.localSelectedItems,
				);
			} else {
				this.localSelectedItems = [...this.localSelectedItems, selectedItem];
			}
			this.$emit('onChange', this.localSelectedItems);
		},
		isSelected(item) {
			const foundIndex = findIndex(
				propEq(this.prop, item[this.prop]),
				this.localSelectedItems,
			);
			return foundIndex > -1;
		},
	},
	watch: {
		selectedOptions: {
			handler(newValue) {
				this.localSelectedItems = newValue;
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>

<style lang="scss">
.p-multi-select {
	border: 1px solid var(--app-color-primary);
	border-radius: 5px;
	padding: 10px;
	user-select: none;

	&:before {
		content: attr(data-content);
		color: var(--app-color-primary);
		position: absolute;
		top: 4px;
	}

	& > * > .flex-display {
		gap: 5px;
	}

	&--icon {
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		height: 0;
		width: 0;
		border-top: 7px solid var(--app-color-primary);
		display: block;
	}

	&--tag {
		border: 1px solid var(--app-color-success);
		color: var(--app-color-success) !important;
		background-color: rgba(#5ed52b, 0.2);
		padding: 2px 5px;
		border-radius: 5px;
		display: flex;
		align-items: center;
		gap: 5px;
		font-size: 10px;

		svg {
			cursor: pointer;
		}
	}

	&--item {
		cursor: pointer;
		text-align: left;
		padding: 8px 16px;
		color: var(--app-color-font-gray);
		border-bottom: 1px solid var(--app-color-gray);

		&__selected {
			background-color: var(--app-color-primary);
			color: white !important;
		}
	}

	.multi-select-menu {
		width: 100% !important;
	}

	.menu-list:last-child .p-multi-select--item {
		border-bottom: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-multi-select.vue